<template>
    <div class="slider">
        <div class="content" :style="{transform: `translateX(${offset}px)`}">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Slider',
        props: {
            value: Number,
            cols: Object,
        },
        data() {
            return {
                gap: 20,
                offset: 0,
                step: 100
            }
        },
        components: {

        },
        computed: {

        },
        methods: {
            left() {
                this.offset += this.$slots.default[this.value - 1].elm.offsetWidth + this.gap
                this.$emit('input', this.value - 1)
            },
            right(){
                this.offset -= this.$slots.default[this.value].elm.offsetWidth + this.gap
                this.$emit('input', this.value + 1)
            }
        },
}
</script>

<style lang="scss" scoped>
    .content{
        display:flex;
        justify-content: space-between;
        align-items: center;
        width:100%;
        transition: 200ms;
    }

</style>
